/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_NowInputs */

const en_update_now = /** @type {(inputs: Update_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Now`)
};

const fr_update_now = /** @type {(inputs: Update_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour maintenant`)
};

const de_update_now = /** @type {(inputs: Update_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt aktualisieren`)
};

const it_update_now = /** @type {(inputs: Update_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna ora`)
};

const ru_update_now = /** @type {(inputs: Update_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить сейчас`)
};

const es_update_now = /** @type {(inputs: Update_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar ahora`)
};

const zh_cn2_update_now = /** @type {(inputs: Update_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即更新`)
};

const ja_update_now = /** @type {(inputs: Update_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ更新`)
};

const hi_update_now = /** @type {(inputs: Update_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी अद्यतन करें`)
};

const pt_pt2_update_now = /** @type {(inputs: Update_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize agora`)
};

/**
* | output |
* | --- |
* | "Update Now" |
*
* @param {Update_NowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_now = /** @type {((inputs?: Update_NowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_NowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_update_now(inputs)
	if (locale === "de") return de_update_now(inputs)
	if (locale === "it") return it_update_now(inputs)
	if (locale === "ru") return ru_update_now(inputs)
	if (locale === "es") return es_update_now(inputs)
	if (locale === "zh-CN") return zh_cn2_update_now(inputs)
	if (locale === "ja") return ja_update_now(inputs)
	if (locale === "hi") return hi_update_now(inputs)
	if (locale === "pt-PT") return pt_pt2_update_now(inputs)
	return en_update_now(inputs)
});